export default __webpack_public_path__ + "static/banner-34fd8e0d05af6267c8506c20a236b55c.jpg";